import React, { useState } from 'react';
import { HiMagnifyingGlass, HiChevronDown, HiChevronUp, HiXMark } from 'react-icons/hi2';
import FadeIn from '../common/FadeIn';

const BlogFilterSection = ({
  categories,
  selectedCategory,
  onCategoryChange,
  searchQuery,
  onSearchChange,
}) => {
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const handleMobileCategoryClick = (cat) => {
    onCategoryChange(cat);
    setIsCategoriesOpen(false);
  };

  return (
    <FadeIn className="mb-8">
      <div className="hidden md:flex w-full border-t border-b border-[#E8E2D8] py-4 items-center justify-between gap-6">
        <div className="flex flex-wrap items-center justify-start gap-x-4 gap-y-2 text-[10px] md:text-[11px] font-interDisplayMedium uppercase tracking-[0.12em]">
          <span className="font-PromenadeItalic text-[13px] md:text-[15px] lowercase tracking-normal text-[#1C1917] capitalize mr-1">
            Browse Categories :
          </span>
          {categories.map((category) => {
            const isActive = selectedCategory === category;
            return (
              <button
                key={category}
                onClick={() => onCategoryChange(category)}
                className={`transition-colors cursor-pointer ${isActive
                  ? 'text-[#1C1917] font-bold border-b border-[#1C1917]'
                  : 'text-[#666666] hover:text-[#1C1917]'
                  }`}
              >
                {category}
              </button>
            );
          })}
        </div>

        <div className="relative w-[260px] flex items-center">
          <input
            type="text"
            placeholder="Search the blog & hit enter"
            value={searchQuery}
            onChange={onSearchChange}
            className="w-full bg-[#f9f6f3] text-[11px] font-interDisplayMedium text-[#1C1917] placeholder-[#8B8477] py-2 pl-3 pr-8 rounded-none focus:outline-none border border-[#E8E2D8]"
          />
          <HiMagnifyingGlass className="absolute right-2.5 w-4 h-4 text-[#8B8477] pointer-events-none" />
        </div>
      </div>

      <div className="block md:hidden w-full border-t border-b border-[#E8E2D8]">
        <div className="py-3 px-1 flex items-center justify-between">
          {isSearchOpen ? (
            <div className="w-full flex items-center justify-between">
              <span className="font-PromenadeItalic text-[22px] italic text-[#1C1917]">
                Search
              </span>
              <button
                onClick={() => setIsSearchOpen(false)}
                className="text-[#1C1917] p-1 cursor-pointer focus:outline-none"
                aria-label="Close search"
              >
                <HiXMark className="w-5 h-5" />
              </button>
            </div>
          ) : (
            <div className="w-full flex items-center justify-between">
              <button
                onClick={() => {
                  setIsCategoriesOpen(!isCategoriesOpen);
                  setIsSearchOpen(false);
                }}
                className="flex items-center gap-2 font-PromenadeItalic text-[22px] italic text-[#1C1917] cursor-pointer focus:outline-none"
              >
                <span>Categories</span>
                {isCategoriesOpen ? (
                  <HiChevronUp className="w-4 h-4 text-[#1C1917]" />
                ) : (
                  <HiChevronDown className="w-4 h-4 text-[#1C1917]" />
                )}
              </button>

              <button
                onClick={() => {
                  setIsSearchOpen(true);
                  setIsCategoriesOpen(false);
                }}
                className="text-[#1C1917] p-1 cursor-pointer focus:outline-none"
                aria-label="Open search"
              >
                <HiMagnifyingGlass className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>

        {isSearchOpen && (
          <div className="pt-2 pb-5 px-2 bg-[#FAF8F5]">
            <div className="relative w-full bg-[#EFECE6] p-2.5 flex items-center">
              <input
                type="text"
                placeholder="Search the blog & hit enter"
                value={searchQuery}
                onChange={onSearchChange}
                className="w-full bg-transparent text-[12px] font-interDisplayMedium text-[#1C1917] placeholder-[#8B8477] py-1 pl-2 pr-8 focus:outline-none"
                autoFocus
              />
              <HiMagnifyingGlass className="absolute right-3.5 w-4 h-4 text-[#8B8477] pointer-events-none" />
            </div>
          </div>
        )}

        {isCategoriesOpen && !isSearchOpen && (
          <div className="py-6 border-t border-[#E8E2D8] flex flex-col items-center gap-5 bg-[#FAF8F5]">
            {categories.map((category) => {
              const isActive = selectedCategory === category;
              return (
                <button
                  key={category}
                  onClick={() => handleMobileCategoryClick(category)}
                  className={`font-interDisplayMedium text-[11px] uppercase tracking-[0.2em] transition-colors cursor-pointer py-1 ${isActive
                    ? 'text-[#1C1917] font-bold border-b border-[#1C1917]'
                    : 'text-[#1C1917] hover:text-[#8B8477]'
                    }`}
                >
                  {category}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </FadeIn>
  );
};

export default BlogFilterSection;
